import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllInvitations = () =>
  apiClient.get(REST_API_BASE_URL + '/invitations');

//export const getAllAppsByAccount = (id) => apiClient.get(`${REST_API_BASE_URL}/message/${id}/apps`);

export const saveInvitation = (invitation) =>
  apiClient.post(REST_API_BASE_URL + '/invitation', invitation);

export const getInvitation = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/invitation/${id}`);

export const updateInvitation = (id, invitation) =>
  apiClient.put(`${REST_API_BASE_URL}/invitation/${id}`, invitation);

export const deleteInvitation = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/invitation/${id}`);

export default apiClient;
